export type TimelineNode = {
  time: string;
  label: string;
  note: string;
  tone: "key" | "turning" | "info";
};

export type TimelineCase = {
  id: string;
  title: string;
  person: string;
  status: string;
  statusTone: string;
  summary: string;
  cover: string;
  nodes: TimelineNode[];
};

export const timelineCases: TimelineCase[] = [
  {
    id: "t1",
    title: "「回锅顶流」三年三次改口全节点",
    person: "舆论风向：从实锤质疑到反转拉锯",
    status: "复盘已更新",
    statusTone: "accent",
    summary:
      "从最初的实锤帖到最新声明，三年里三次关键改口都被逐条对齐。哪些是证据、哪些是猜测，时间线上一目了然。",
    cover:
      "https://readdy.ai/api/search-image?query=three%20old%20photographs%20and%20notes%20pinned%20to%20a%20warm%20corkboard%20with%20red%20string%20connecting%20them%2C%20amber%20lighting%2C%20symbolic%20of%20connecting%20multiple%20statements%20over%20time%2C%20no%20people%2C%20no%20readable%20text%2C%20investigative%20editorial%20composition&width=720&height=460&seq=timeline-01&orientation=landscape",
    nodes: [
      { time: "第一年 · 春季", label: "实锤帖首发", note: "多条截图与切片被集中放出，讨论迅速破万。", tone: "key" },
      { time: "第二年 · 年中", label: "首次回应改口", note: "措辞从否认转向「解释」，首次出现矛盾点。", tone: "turning" },
      { time: "第三年 · 今春", label: "二次声明与考据", note: "新考据把时间线又前推，二次声明再被逐句解读。", tone: "turning" },
    ],
  },
  {
    id: "t2",
    title: "女主播停播第 9 天 · 去向成谜",
    person: "停播原因：直播公告 vs 粉丝考据",
    status: "持续跟进",
    statusTone: "primary",
    summary:
      "停播公告只给了一句话，粉丝与主播之间的信息差越拉越大。我们把每天的公开信号整理成一条可回看的轴。",
    cover:
      "https://readdy.ai/api/search-image?query=an%20empty%20studio%20chair%20in%20front%20of%20a%20dark%20screen%20with%20a%20single%20warm%20side%20light%2C%20amber%20and%20charcoal%20tones%2C%20symbolic%20of%20a%20suspended%20livestream%20and%20absence%2C%20no%20people%2C%20no%20text%2C%20cinematic%20editorial%20minimal%20composition&width=720&height=460&seq=timeline-02&orientation=landscape",
    nodes: [
      { time: "第 1 天", label: "突然停播", note: "开播前 10 分钟临时取消，粉丝群开始讨论。", tone: "key" },
      { time: "第 4 天", label: "发布停播公告", note: "措辞模糊，未说明原因与回归时间。", tone: "turning" },
      { time: "第 9 天", label: "账号低调改名", note: "昵称后缀变动引发新一轮时间线考据。", tone: "info" },
    ],
  },
  {
    id: "t3",
    title: "电竞「山哥」合同争议第 11 天",
    person: "转会风波：俱乐部说法 vs 选手回应",
    status: "反转拉锯中",
    statusTone: "secondary",
    summary:
      "合同条款前后两版说法冲突，实锤讨论区已开出多条证据帖，后续进展更新到第 11 天仍未落地。",
    cover:
      "https://readdy.ai/api/search-image?query=contract%20documents%20with%20a%20signed%20section%20and%20a%20keyboard%20silhouette%20on%20a%20desk%2C%20warm%20desk%20lamp%20and%20vermillion%20accent%2C%20symbolic%20of%20esports%20contract%20dispute%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20mood&width=720&height=460&seq=timeline-03&orientation=landscape",
    nodes: [
      { time: "第 1 天", label: "转会爆料流出", note: "转会去向传闻出现，未获任何一方确认。", tone: "info" },
      { time: "第 5 天", label: "俱乐部发声明", note: "列出原合同说法，称球员擅自接触下家。", tone: "key" },
      { time: "第 11 天", label: "选手方晒截图", note: "晒出补充协议截图，双方说法出现正面冲突。", tone: "turning" },
    ],
  },
];